import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import React from 'react';

type Props = {
  questionId: number;
  fileName: string;
  disabled?: boolean;
  canEdit: boolean;
  onFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectFileLabel: string;
  helperText: string;
};

export function DataUploadFileSection({
  questionId,
  fileName,
  disabled,
  canEdit,
  onFileUpload,
  selectFileLabel,
  helperText,
}: Props) {
  return (
    <>
      <Stack direction='row' alignItems='center' gap='10px' maxWidth='550px'>
        <input
          id={`file-${questionId}`}
          type='file'
          name='file'
          multiple
          style={{ display: 'none' }}
          onChange={onFileUpload}
          disabled={disabled}
        />
        <TextField
          style={{ width: '350px' }}
          placeholder={selectFileLabel}
          id='file-selected'
          value={fileName}
          disabled
        />
        {canEdit && (
          <label htmlFor={`file-${questionId}`}>
            <Button variant='secondary' size='small' component='span'>
              {selectFileLabel}
            </Button>
          </label>
        )}
      </Stack>
      <Box maxWidth='550px' mt='8px'>
        <Typography variant='subtitle3' color='textSecondary'>
          {helperText}
        </Typography>
      </Box>
    </>
  );
}
